import moment from "moment";
import { regex } from "../../views/pages/manage/common/constant";

export const inputFilters = [
  {
    label: 'PSID',
    keyName: 'psid',
    placeholder: 'Search by psid',
    errorMsg: 'Please enter 11 digit psid.',
    regex: regex.numeric,
    isValidInput: val => val?.length === 11,
    validLength: 11
  },
  {
    label: 'Application ID',
    keyName: 'applicationId',
    placeholder: 'Search by application id',
    errorMsg: 'Please enter 9 digit application id.',
    regex: regex.numeric,
    isValidInput: val => val?.length === 8,
    validLength: 8
  },
  {
    label: 'Name',
    keyName: 'studentName',
    placeholder: 'Search by name',
    errorMsg: 'Please enter name.',
    // regex: regex.alphaNumericWithSpaceAndUnderscore,
    // isValidInput: val => val?.length === 11,
    // validLength: 11
  },
]

export const initialForm = {
  businessAreaValues: [],
  terms: [],
  discDateFrom: null,
  discDateTo: null,
  followUpDateFrom: null,
  followUpDateTo: null,
  cashierValues:[]
}

export const getFilterFormFields = (dropdownData, reqForm,tabKey) => {
  const { businessAreas = [], terms = [], cashierOffice,} = dropdownData || {};

  return [
    {
      label: 'BU Code',
      type: 'select',
      items: businessAreas,
      formKey: 'businessAreaValues',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Cashier Office',
      type: 'select',
      items: cashierOffice,
      formKey: 'cashierValues',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Term',
      type: 'select',
      items: terms,
      formKey: 'terms',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Discontionue Date Range From',
      type: 'date',
      formKey: 'discDateFrom',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: '',
      maxDate: reqForm?.discDateTo||moment(new Date()),
    },

    {
      label: 'Discontionue Date Range To',
      type: 'date',
      formKey: 'discDateTo',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: reqForm?.discDateFrom,
      maxDate:  moment(new Date()),
    },
      ...(tabKey=="FOLO"?[{
      label: 'FOLO Date From',
      type: 'date',
      formKey: 'followUpDateFrom',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: '',
      maxDate:  reqForm?.followUpDateTo||moment(new Date()),
    },
    {
      label: 'FOLO Date  To',
      type: 'date',
      formKey: 'followUpDateTo',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: reqForm?.followUpDateFrom,
      maxDate:  moment(new Date()),
    },]:[])
  ]
}

export const dummyRows = [
  {
    id:1,
    psid: "PSID-1001",
    applicationId: "APP-202401",
    studentName: "Rahul Sharma",
    buCode: "BU-DEL",
    status: "Pending",
    discDate: "10-Jan-2026",
    outstandingAmt: "₹25,000",
    remarks: "Follow up required",
    reminderDate: "15-Jan-2026"
  },
  {
    id:2,
    psid: "PSID-1002",
    applicationId: "APP-202402",
    studentName: "Ananya Verma",
    buCode: "BU-MUM",
    status: "Completed",
    discDate: "05-Jan-2026",
    outstandingAmt: "₹0",
    remarks: "Payment received",
    reminderDate: "-"
  },
  {
    id:3,
    psid: "PSID-1003",
    applicationId: "APP-202403",
    studentName: "Amit Singh",
    buCode: "BU-BLR",
    status: "Overdue",
    discDate: "28-Dec-2025",
    outstandingAmt: "₹12,500",
    remarks: "Escalated to finance",
    reminderDate: "20-Jan-2026"
  }
];


export const statusColors = {
    "DISC" : {text : 'DISC' , bgColor: "#F9D9D7", textColor: "#B32306" },
    "FOLO" : {text : 'FOLO' , bgColor: "#FFEDC8", textColor: "#705010" },
    "APPL" : {text : 'APPL' , bgColor: "#BBE2CE", textColor: "#0B442D" },
    "MATR" : {text : 'MATR' , bgColor: "#CCEFFD", textColor: "#006A93" },
    "RADM" : {text : 'RADM' , bgColor: "#FFEDC8", textColor: "#705010" },
} 
